import client from 'lib/api/client';

interface IBillingKeyData {
  customer_uid: string;
  card_number: string;
  pwd_2digit: string;
  expiry: string;
  birth: string;
}

export const getTelemedicineAuth = () => {
  // 해당 API는 위드비컨 서비스 access token을 필요로 하기 때문에 위드비컨 앱 axios instance를 사용합니다.
  return client.get('/telemedicine/auth');
};

export const postSelfCertificationData = (impUid: string) => {
  return client.post('/telemedicine/diagnosis/patient/certification', {
    impUid,
  });
};

interface ISelfCertificationData {
  authResult: boolean;
  authInfo: {
    birthday: string;
    phoneNumber: string;
    name: string;
  };
}

export const getSelfCertificationData =
  async (): Promise<ISelfCertificationData> => {
    const res = await client.get<Promise<ISelfCertificationData>>(
      '/telemedicine/diagnosis/patient/certification',
    );
    return res.data;
  };

export const setAuthorization = (accessToken: string) => {
  client.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
};

export const getBillingKeyData = () => {
  return client.get('/telemedicine/patient/billing-key');
};

export const createBillingKey = (billingKeyData: IBillingKeyData) => {
  return client.post('/telemedicine/patient/billing-key', {
    customer_uid: billingKeyData.customer_uid,
    card_number: billingKeyData.card_number,
    pwd_2digit: billingKeyData.pwd_2digit,
    expiry: billingKeyData.expiry,
    birth: billingKeyData.birth,
  });
};

export const modifyBillingKey = (billingKeyData: IBillingKeyData) => {
  return client.put('/telemedicine/patient/billing-key', {
    customer_uid: billingKeyData.customer_uid,
    card_number: billingKeyData.card_number,
    pwd_2digit: billingKeyData.pwd_2digit,
    expiry: billingKeyData.expiry,
    birth: billingKeyData.birth,
  });
};
